import { render } from "./ReportStockMovement.vue?vue&type=template&id=2deabd01&scoped=true"
import script from "./ReportStockMovement.vue?vue&type=script&lang=js"
export * from "./ReportStockMovement.vue?vue&type=script&lang=js"

import "./ReportStockMovement.vue?vue&type=style&index=0&id=2deabd01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2deabd01"]])

export default __exports__